import { useQuery } from 'react-query';

import api, { QueryConfig } from '@shared/api';

type PredicatesParams = {
  predicatesBatchId: string | null;
};

type PredicatesResponse = {
  predicates: string[];
};

const getPredicates = async (predicatesBatchId: string | null) => {
  if (!predicatesBatchId) return [];

  const { data } = await api.get<PredicatesResponse>(
    `/mpm/v2/predicates/${predicatesBatchId}`
  );

  return data.predicates;
};

export function usePredicates(
  params: PredicatesParams,
  config?: QueryConfig<string[]>
) {
  const { predicatesBatchId } = params;
  return useQuery(
    ['mpm-druid-predicates', { predicatesBatchId }],
    () => getPredicates(predicatesBatchId),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      ...config,
      enabled: (config?.enabled ?? true) && !!predicatesBatchId
    }
  );
}
